import { TravellerDocumentFields } from '../../../types';
import {
	OptionParameter,
	ProfileDocumentFragment,
	TravellerFieldEnum,
	TravellerProfileFragment
} from '@websky/graphql';
import { CisCountries } from '../../../consts';

export const generateCountriesMap = (traveller: TravellerProfileFragment, primaryCountryCodes?: string[]) => {
	const map = new Map<string, number>();
	const countries = traveller?.values.find(field => field.name === TravellerFieldEnum.Nationality.toLowerCase())
		.validationRules[0].options;

	const filteredCISCountries = countries?.filter(country => CisCountries.includes(country.value));

	if (primaryCountryCodes?.length) {
		const primaryCountries = countries?.filter(country => primaryCountryCodes.includes(country.value)).reverse();

		primaryCountries?.forEach((country, index) => map.set(country.label, index));
	}

	const position = primaryCountryCodes?.length || 0;

	filteredCISCountries?.forEach((country, index) => {
		if (!map.has(country.label)) {
			map.set(country.label, position + index);
		}
	});

	return map;
};

export const getCitizenships = (traveller: TravellerProfileFragment, primaryCountryCodes?: string[]) => {
	const cisCountriesMap = generateCountriesMap(traveller, primaryCountryCodes);

	const sortCountries = ({ label: a }: OptionParameter, { label: b }: OptionParameter) => {
		if (cisCountriesMap.has(a) && !cisCountriesMap.has(b)) {
			return -1;
		} else if (cisCountriesMap.has(a) && cisCountriesMap.has(b)) {
			return cisCountriesMap.get(a) - cisCountriesMap.get(b);
		}

		return 0;
	};

	return traveller?.values
		.find(field => field.name === TravellerFieldEnum.Nationality.toLowerCase())
		.validationRules[0].options?.sort(sortCountries);
};

export const getDocumentTypes = (citizenship?: string, validators?: ProfileDocumentFragment) => {
	if (!validators) {
		return [];
	}

	const docType = validators.values.find(value => value.name === TravellerDocumentFields.DocType);
	const documentsForCitizenship = docType?.validationRules.find(rule => {
		return rule.with?.find(item => item.name === TravellerDocumentFields.Citizenship && item.value === citizenship);
	});

	if (documentsForCitizenship) {
		return documentsForCitizenship.options.map(item => item.value);
	} else {
		return docType?.validationRules.find(rule => !rule.with).options.map(item => item.value);
	}
};

export const getAvailabilityDocumentExpireDate = (documentType: string, validators?: ProfileDocumentFragment) => {
	const docExpireValidations = validators?.values?.find(value => value.name === TravellerDocumentFields.DocExpiryDate)
			?.validationRules,
		docTypeRule = docExpireValidations?.find(validation =>
			validation.with?.find(item => item.name === TravellerDocumentFields.DocType && item.value === documentType)
		);

	return !docTypeRule?.required;
};
